import { render, staticRenderFns } from "./DadoPessoal.vue?vue&type=template&id=f02158d8&scoped=true&"
import script from "./DadoPessoal.vue?vue&type=script&lang=js&"
export * from "./DadoPessoal.vue?vue&type=script&lang=js&"
import style0 from "./DadoPessoal.vue?vue&type=style&index=0&id=f02158d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02158d8",
  null
  
)

export default component.exports